import { Sparkles, RefreshCw, Check, Loader2 } from "lucide-react";
import { Panel } from "./Panel";

export const StillPanel = ({ logo, still, approved, onMake, onApprove }) => {
  const rendering = still?.status === "rendering";
  const done = still?.status === "done";

  return (
    <Panel step="02 / Chrome still" title="Green chrome look" testid="still-panel">
      <p className="text-sm text-gray-400 mb-5 leading-relaxed">
        AI turns the flat logo into 3D green chrome. Check it on the stage, then approve it or try again.
      </p>
      {rendering ? (
        <div data-testid="still-rendering" className="scan rounded-xl border border-[#1e2638] px-4 py-4 text-sm flex items-center gap-3 mb-4">
          <Loader2 className="w-4 h-4 animate-spin text-[#00ff87]" /> Making chrome still… about 30–60 s
        </div>
      ) : null}
      {still?.status === "failed" && (
        <div data-testid="still-error" className="rounded-xl border border-red-500/30 bg-red-500/5 text-red-300 text-sm px-4 py-3 mb-4">
          {still.error}
        </div>
      )}
      {!done && !rendering ? (
        <button data-testid="make-still-button" disabled={!logo} onClick={onMake}
          className="btn-chrome w-full rounded-full py-3.5 font-semibold flex items-center justify-center gap-2">
          <Sparkles className="w-4 h-4" /> Make chrome still
        </button>
      ) : (
        <div className="flex gap-3">
          <button data-testid="regenerate-still-button" disabled={rendering || !logo} onClick={onMake}
            className="btn-ghost flex-1 rounded-full py-3 text-sm flex items-center justify-center gap-2">
            <RefreshCw className="w-4 h-4" /> Regenerate
          </button>
          <button data-testid="approve-still-button" disabled={!done || approved} onClick={onApprove}
            className="btn-chrome flex-1 rounded-full py-3 text-sm font-semibold flex items-center justify-center gap-2">
            <Check className="w-4 h-4" /> {approved ? "Approved" : "Approve"}
          </button>
        </div>
      )}
    </Panel>
  );
};
